import React from "react";

function CloudOneMigration() {
  return <h2>Cloud One Migration & Support</h2>;
}

export default CloudOneMigration;
